// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"907":"572b99fb","945":"3373c0bb"}[chunkId] + ".css";
};